import type { DocumentPageMetadataUserEditSource } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

export function resolveUserEditsWriteSource(args: {
  hasReviewer: boolean
  hasLabeler: boolean
}): DocumentPageMetadataUserEditSource {
  if (args.hasReviewer) return 'reviewer'
  if (args.hasLabeler) return 'labeler'
  return 'editor'
}
